module.exports = __webpack_public_path__ + "static/media/noAccess.c204946e.png";